import { useQuery } from '@tanstack/react-query';
import user from 'stores/user';

const PRE_MINING_API = process.env.REACT_APP_PRE_MINING_API;

interface PreMiningResponse {
    success: boolean;
    data: boolean;
}

async function checkPreMining(address: string): Promise<PreMiningResponse> {
    const response = await fetch(`${PRE_MINING_API}/receive_reward/check_address?address=${address}`);

    if (!response.ok) {
        throw new Error('Failed to fetch pre mining data');
    }

    return response.json() as Promise<PreMiningResponse>;
}

export default function usePreMining() {
    const { data, isLoading, error } = useQuery({
        queryKey: ['preMining', user.address],
        queryFn: () => checkPreMining(user.address || ''),
        enabled: !!user.address,
        refetchInterval: 1000 * 60,
        refetchOnWindowFocus: false,
        retry: 1
    });

    return {
        hasPreMined: data?.success && data?.data,
        isLoading,
        error,
    };
}
